module.exports = __webpack_public_path__ + "static/img/3.86ccf1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/line/3.jpg
// module id = XBkF
// module chunks = 1